import Utils from "../../../helpers/Utils"

const OutSideConstants = {
    deal_currency : '$',
    starterPack: Utils.getAccountData('starterPack'),
    authId:  Utils.getAccountData('userId')
}
export default OutSideConstants